<div class="jumbotron">
    <h1 class="text-center">Report Builder - Individual Reporting</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                <div class="p-3">
                    <div
                        cmpsTdBuilderUsageIndividualSelectionReport
                        [params]="selectedParams"
                        [peerGroups]="peerGroups"
                        [superGroups]="superGroups"
                        [roles]="roles"
                        [reportPopulations]="reportPopulations"
                        (generated)="onGeneratedReport($event)"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Individual Report
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>

                <div
                    class="p-3"
                    *ngIf="!pendingData && noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>

                <div
                    class="p-3"
                    *ngIf="!pendingData && !noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            title="Refresh"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            class="btn-mini"
                            title="Export"
                            (click)="onExportClick()"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>

                    Report Population:
                    <b class="f-s-75-2">{{ selectedPopulationType }}</b>
                    <span class="soft-pipe">|</span>
                    Selected: <b class="f-s-75-2">{{ selectedPopulation }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Start Date:
                    <b class="f-s-75-2">{{ this.params.startDate }}</b>
                    <span class="soft-pipe">|</span>
                    Selected End Date:
                    <b class="f-s-75-2">{{ this.params.endDate }}</b>

                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div>User Name</div>
                                </th>
                                <th
                                    class="title even"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">Role</div>
                                </th>
                                <th
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div>Manager</div>
                                </th>
                                <th
                                    class="title even"
                                    [style.min-width]="'100px'"
                                >
                                    <div>Super Group</div>
                                </th>
                                <th
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div>Reports Generated</div>
                                </th>
                            </tr>

                            <ng-template
                                ngFor
                                let-row
                                let-i="index"
                                [ngForOf]="groups"
                            >
                                <tr (click)="expandRow(i)">
                                    <td
                                        class="text-center vertical-center"
                                        [ngClass]="{
                                            expandedRow: expandedRows[i]
                                        }"
                                    >
                                        <span class="tableHeader">
                                            <cmps-icon
                                                [svgIcon]="
                                                    expandedRows[i]
                                                        ? 'chevron-down'
                                                        : 'chevron-right'
                                                "
                                                *ngIf="row.dateList.length > 0"
                                            ></cmps-icon>
                                            {{ row.userName }}
                                        </span>
                                    </td>
                                    <td
                                        class="text-center vertical-center"
                                        [ngClass]="{
                                            expandedRow: expandedRows[i]
                                        }"
                                    >
                                        {{ row.role }}
                                    </td>
                                    <td
                                        class="text-center vertical-center"
                                        [ngClass]="{
                                            expandedRow: expandedRows[i]
                                        }"
                                    >
                                        {{ row.manager }}
                                    </td>
                                    <td
                                        class="text-center vertical-center"
                                        [ngClass]="{
                                            expandedRow: expandedRows[i]
                                        }"
                                    >
                                        {{ row.superGroup }}
                                    </td>
                                    <td
                                        class="text-center vertical-center"
                                        [ngClass]="{
                                            expandedRow: expandedRows[i]
                                        }"
                                    >
                                        {{ row.dateList.length }}
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="expandedRows[i]"
                                    class="generatedRow"
                                >
                                    <td class="text-center">
                                        {{ generatedTimesLabel }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <ul class="dateList">
                                            <li
                                                class="text-center"
                                                *ngFor="
                                                    let times of row.dateList
                                                "
                                            >
                                                {{
                                                    times
                                                        | cmpsDate
                                                            : 'yyyy-MM-dd HH:mm:ss'
                                                }}
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </ng-template>
                        </table>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
